$(document).ready(function () {
 
    var lastScrollTop = 0;
    var navbar = document.getElementById("navbar");
    window.addEventListener("scroll",function(){
       var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
       if(scrollTop > lastScrollTop){
             navbar.style.top = "-170px";
       }else{
             navbar.style.top = "0";
       }
       lastScrollTop = scrollTop;
    });



    /*Scroll top*/
    var scrollTop = $(".scrollTop");
    $(window).scroll(function () {
        var topPos = $(this).scrollTop();
        if (topPos > 0) {
            $(scrollTop).css("opacity", "1");
        } else {
            $(scrollTop).css("opacity", "0");
        }
    });
    $(scrollTop).click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 600);
        return false;
    });
    /*Menu dropdown*/
    var ico = $('<i class="fa fa-angle-down menudrop"></i>');
    $('.menu_link li:has(.submenu) > a').append(ico);
    $('.menudrop').on('click', function (e) {
        $(this).parent().parent().addClass('no-hover');

        $('.menu_link ul li').not($(this).parent().parent()).find('.submenu').stop(true, true).delay(200).fadeOut(500);
        $('.menu_link ul li').not($(this).parent().parent()).removeClass('open');
        $('.menu_link ul li a .menudrop').not($(this)).removeClass('openedmenu');
        $('.menu_link ul li a .menudrop').not($(this)).addClass('closemenu');

        e.preventDefault();
        if ($(this).hasClass('openedmenu')) {
            $(this).parent().parent().find('.submenu').stop(true, true).delay(200).fadeOut(500);
            $(this).removeClass('openedmenu');
            $(this).addClass('closemenu');

        } else {
            $(this).parent().parent().find('.submenu').stop(true, true).delay(200).fadeIn(500);
            $(this).removeClass('closemenu');
            $(this).addClass('openedmenu');
        }
    });


    if ($(window).width() >= 1120) {
        $(".menu_link nav > ul > li.has-sub").hover(
            function () {
                $('body').addClass("menuoverlay");
                $(window).trigger('resize');
            },
            function () {
                $('body').removeClass("menuoverlay");
            }
        );
    }

    /*-----BURGER MENU-----*/
    $(".togglebtn, .overlay").click(function () {
        $(".togglebtn, .overlay, .menu_link").toggleClass("active");
        if ($(".overlay").hasClass("active")) {
            $(".overlay").fadeIn();
            $('html').addClass('menuhidden');
        } else {
            $(".overlay").fadeOut();
            $('html').removeClass('menuhidden');
        }
    });

    /*-----FIXED HEADER-----*/

    $(window).scroll(function () {
        if (($(window).scrollTop() > 200) && ($(window).width() >= 319)) {
            $('body > main').css('paddingTop', $('.shopify-section-group-header-group > header').outerHeight());
            $('body').addClass('fixed-header');
        } else {
            $('body > main').css('paddingTop', '');
            $('body').removeClass('fixed-header');
        }
    });

    // FOOTER

    $(".ft-block2 .acc-nav-head").click(function () {
        if ($(window).width() < 768) {
            let $this = $(this);

            $this.toggleClass('showhide');

            let $wrapper = $this.closest('.ft-block2');
            let $heads = $wrapper.find('.acc-nav-head');

            $heads.not($this).removeClass('showhide');
            $heads.not('.showhide').siblings().stop().slideUp(300);
            $heads.filter('.showhide').siblings().stop().slideDown(300);
        }
    });

    let window_view_sizes = [993];
    let window_views = {};

    $(window).on('load resize orientationchange', function () {
        window_view_sizes.forEach(function (window_view_size) {
            if (this.innerWidth < window_view_size) {
                if (window_views[window_view_size] !== 'mobile') {
                    window_views[window_view_size] = 'mobile';
                    $(window).trigger('mobile_view_switch_' + window_view_size);
                }
            } else {
                if (window_views[window_view_size] !== 'desktop') {
                    window_views[window_view_size] = 'desktop';
                    $(window).trigger('desktop_view_switch_' + window_view_size);
                }
            }
        });
    });

    $(window).on('desktop_view_switch_993', function () {
        $.each($('.sum_column_mobile > *'), function () {
            $('.sum_column_desktop').append($(this));
        });

        $.each($('.price_box_mobile > *'), function () {
            $('.price_box_desktop').append($(this));
        });
    });

    $(window).on('mobile_view_switch_993', function () {
        $.each($('.sum_column_desktop > *'), function () {
            $('.sum_column_mobile').append($(this));
        });

        $.each($('.price_box_desktop > *'), function () {
            $('.price_box_mobile').append($(this));
        });
    });

    $(window).trigger('load');

    let load_currencies = setInterval(function () {
        if ($('.locale-selectors__container').length) {
            let $country_code = $('#country_code');

            $('#country, #country-head, #country-head-mobile')
                .html($country_code.html())
                .val($country_code.val())
                .selectBoxIt()
                .on('changed', function (ev, obj) {
                    $country_code.val(obj.selectbox.val());
                    $country_code[0].dispatchEvent(new Event('change'));
                });

            clearInterval(load_currencies);
        }
    }, 500);
});

/* popup on load */

window.onload = function () {
    if ($('#modal-close').length) {
        document.getElementById('modal-close').onclick = function () {
            document.getElementById('bonus-modaloverlay').style.display = 'none'
        };
    }
};
